<template>
  <div class="powerpoint-wrapper">
    <div class="powerpoint-container">
      <!-- <div class="text-container"> </div> -->
      <tr-ui-title
        v-for="(title, index) in [powerpoint.powerpointObj]"
        :key="powerpoint.id + '_' + index"
        class="free-position"
        :style="getCustomStyle(powerpoint.powerpointObj)"
        :title-text="title.text"
        :audio="title.audio"
        :pos="title.pos"
        :width="730"
        :height="145"
      ></tr-ui-title>
      <div class="image-container">
        <div
          class="image-element"
          title="Aby rozpocząć, kliknij w przycisk."
          @click="powerpointLuncher(powerpoint.powerpointObj.item.path)"
        >
          <img draggable="false" :src="imagePath(powerpoint.icon)" class="icon-off" />
          <img draggable="false" :src="imagePath(powerpoint.icon, false)" class="icon-on" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import TrUiTitle from '__mainSrcDir/components/TrGame/v4/UI/TrUiTitle/TrUiTitle';
export default {
  name: 'lm-power-point',
  components: {
    TrUiTitle,
  },
  methods: {
    openFile(link) {
      const path = require('path');
      let fullLink;
      let base;
      if (!this.$store.getters.isWeb) {
        if (require('os').platform() === 'win32') {
          console.log('WIN32');
          base = path.win32.resolve();
        } else {
          console.log('LINUX');
          base = path.posix.resolve();
        }
        fullLink = path.join(base, '/static/' + link);
        this.$electron.shell.openItem(fullLink);
      } else {
        let tmplink = link;
        let url = document.createElement('a');
        url.href = '/static/' + tmplink;
        url.download = tmplink.substr(tmplink.lastIndexOf('/') + 1);
        console.log(url);
        url.click();
      }
    },
    powerpointLuncher(link) {
      if (link) {
        this.openFile(link);
        return true;
      }
      return false;
    },
    imagePath(iconId, off = true) {
      iconId = 'ikonapowerpoint';
      let images = require.context('../../../assets/icons/book/powerpointIcons/', false, /\.png$/);
      return images('./' + iconId + '.png');
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    powerpoint() {
      return this.$store.getters.powerpointData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>
<style lang="scss" scoped>
.powerpoint-wrapper {
  width: 100%;
  height: 100%;
}
.powerpoint-container {
  width: 850px;
  height: 350px;
  z-index: 999;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .image-container {
    position: relative;
    pointer-events: auto;
    top: 180px;
    left: 345px;
    width: 179px;
    height: 143px;
    .image-element {
      width: 100%;
      height: 100%;
      z-index: 1005;
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      visibility: visible;
      opacity: 1;
      cursor: pointer;
      // transition: visibility 0s, opacity 0.3s ease-in;
    }
    .image-element .icon-off {
      visibility: visible;
      opacity: 1;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1006;
      width: 100%;
      height: 100%;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      transition: visibility 0s, opacity 0.3s ease-out;
    }
    .image-element .icon-on {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1006;
      width: 100%;
      height: 100%;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      transition: visibility 0s, opacity 0.3s ease-out;
    }
    .image-element:hover .icon-on {
      visibility: visible;
      opacity: 1;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      // transition: visibility 0s, opacity 0.3s ease-in;
    }
    // }
  }
  .free-position {
    position: absolute;
    pointer-events: auto;
    z-index: 1006;
  }
}
</style>
